import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Avatar, Box, Popper } from '@material-ui/core';
import { UserInfoWithLzPzus } from 'api';
import { setUserAvatarId } from 'features/service/user-controller/api';
import { EQueryConst } from 'features/service/config';
import { useStyles as useStylesBase } from './common/styles/base';
import { avatarsList } from '../HeaderProfile/common/utils';

interface IProps {
  open: boolean;
  id: string | undefined;
  anchorPopper: null | SVGSVGElement;
  user?: UserInfoWithLzPzus;
  handleClose: () => void;
}

export const UserPopper: React.FC<IProps> = React.memo(({ open, id, anchorPopper, user, handleClose }) => {
  const classes = useStylesBase();
  const queryClient = useQueryClient();
  const { mutateAsync: mutateSetAvatarId } = useMutation(setUserAvatarId, {
    onSuccess: () => queryClient.invalidateQueries(EQueryConst.CURRENT_USER),
  });

  const onClickHanlder = async (event: React.MouseEvent<HTMLButtonElement>, avatarId: number) => {
    event.stopPropagation();
    event.preventDefault();
    try {
      await handleClose();
      await mutateSetAvatarId({ userId: Number(user?.id), avatarId });
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
    }
  };

  return (
    <Popper className={classes.root} open={open} id={id} anchorEl={anchorPopper} placement='left'>
      <Box style={{ color: '#18181C', fontWeight: 600 }}>Выберите аватар пользователя</Box>
      <ul style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
        {avatarsList.map(el => (
          <li key={el.id} className={classes.listItem}>
            <button onClick={e => onClickHanlder(e, el.id)}>
              {el.avatar && <Avatar src={el.avatar} style={{ paddingLeft: 2 }} />}
            </button>
          </li>
        ))}
      </ul>
    </Popper>
  );
});
